import { InputAdornment, SxProps, TextField } from '@mui/material';
import { useCallback } from 'react';

interface SpendInputProps {
  autoFocus?: boolean;
  label?: string;
  fullWidth?: boolean;
  id: string;
  isValid: boolean;
  helperText?: string;
  onChange: (value: number) => void;
  sx?: SxProps;
  value: number;
  maxLength?: number;
}

const SpendInput = ({
  autoFocus,
  label = undefined,
  fullWidth,
  id,
  isValid,
  helperText = 'Please choose a value below $100,000.',
  onChange,
  sx,
  value,
  maxLength = 7,
}: SpendInputProps) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e?.target;
      const parsedValue = Number(value.replace(/\D/g, ''));
      if (!isNaN(parsedValue)) {
        onChange(parsedValue);
      }
    },
    [onChange]
  );
  return (
    <TextField
      fullWidth={fullWidth}
      label={label}
      error={!isValid}
      helperText={!isValid && helperText}
      id={id}
      inputRef={(input) => autoFocus && input && input.focus()}
      inputProps={{ inputMode: 'numeric', maxLength }}
      InputProps={{
        startAdornment: <InputAdornment position="start">$</InputAdornment>,
      }}
      onChange={handleChange}
      onFocus={(e) =>
        e.currentTarget.setSelectionRange(
          e.currentTarget.value.length,
          e.currentTarget.value.length
        )
      }
      size="small"
      sx={sx}
      variant="outlined"
      value={value?.toLocaleString('en-US')}
    />
  );
};

export default SpendInput;
